import _ from 'lodash'

export interface PaymentErrorReason {
  message: string
  /**
   * data内部のフォーマットには、必ずしもerror_codeが存在していない模様。
   * どういうときにどういうフォーマットになるのか不明なので、ポリモーフィックに表現することは諦め、
   * いったんoptional(?)で逃げている。
   * cf. https://github.com/my-color/front/issues/5512#issuecomment-904418956
   */
  data: {
    error_code?: string
  }
}

export function getPaymentErrorMessage(reason: PaymentErrorReason): string | null {
  const message = reason.message
  switch (message) {
    /**
     * https://github.com/my-color/front/issues/5512#issuecomment-904418956
     * 与信関係のエラーは、kuroneko, paygent共に独自にMC側でmessageをセットしている。
     * （そもそもクロネコ専用のmessageではなく、クロネコのエラーコードによらずに識別している）
     * https://www.chatwork.com/#!rid87550748-1479098756707123200
     */
    case 'authorization_failed':
      return `ご入力いただいたクレジットカード情報で決済ができませんでした。カード会社にお問い合わせいただくか、別のクレジットカードをご利用ください。
      一定回数エラーになると、カードのご利用が制限される場合がありますのでご注意ください。`
  }

  const errorCode = reason.data.error_code
  switch (errorCode) {
    /**
     * クロネコエラーコード: A081010802
     * P.98 エラーコード一覧参照
     * @see https://www.chatwork.com/#!rid117706251-1195276065329684480
     */
    case 'A081010802':
      return 'メールアドレスが長すぎる（最大64文字）ため、注文を完了できませんでした。'
    /**
     * コンビニ決済 登録メールアドレス誤り
     * @see https://github.com/my-color/front/issues/5091
     */
    case 'B011010871': // セブンイレブン
    case 'B021011071': // ファミリーマート
    case 'B031010971': // ローソン
    case 'B051010971': // ミニストップ
    case 'B061010971': // セイコーマート
      return 'メールアドレスに記号が含まれる場合、決済情報を登録できない場合があります。ご登録のメールアドレスをご確認ください。または、他のお支払い方法でご注文ください。'
    /**
     * コンビニ決済 登録メールアドレス 桁数（文字数）オーバー
     * @see https://github.com/my-color/front/issues/5091
     */
    case 'B011010802': // セブンイレブン
    case 'B021011002': // ファミリーマート
    case 'B031010902': // ローソン
    case 'B051010902': // ミニストップ
    case 'B061010902': // セイコーマート
      return 'メールアドレスが51文字以上の場合、決済情報を登録できない場合があります。ご登録のメールアドレスをご確認ください。または、他のお支払い方法でご注文ください。'
    default:
      return null
  }
}
